import { render } from "./CustomMenuItem.vue?vue&type=template&id=67111347&ts=true"
import script from "./CustomMenuItem.vue?vue&type=script&lang=ts"
export * from "./CustomMenuItem.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Projects\\Finity\\Pulse\\Frontend\\Cedita.Pulse.Web.Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__